// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";

.frm-grp {
  margin-bottom: 1.3rem;
}
.frm-grp.half {
  width: 48%;
  display: inline-block;
}
.frm-grp.right {
  float: right;
}

.mr-15 {
  margin-right: 15px;
}

.flexCenter {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.flexColumn {
  display: flex;
  flex-direction: column;
}

.flex {
  display: flex;
}

.theme_btn {
  background: linear-gradient(90deg, #16b3d5 2.47%, #05c4ab 100%);
  border-radius: 40px;
}

.outline_btn {
  font-weight: 400;
  border-radius: 50px;
}
.outline_btn:hover {
  background-color: #16b3d5;
  color: #fff;
}

.success {
  color: #4caf50;
}

.error {
  color: #f44336;
}

.successActive::before {
  position: absolute;
  right: 12%;
  top: 28%;
  content: "" !important;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 1px solid #15f446;
  background: #15f446;
}

.inActive::before {
  position: absolute;
  right: 12%;
  top: 28%;
  content: "" !important;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 1px solid #a7b5c6;
  background: #a7b5c6;
}

.errorActive::before {
  content: " ●";
  font-size: 20px;
  color: red;
}

.commanBtnStyle {
  border-radius: 40px;
}

.settingLabel {
  padding-top: 8px;
  padding-bottom: 8px;
  padding-left: 16px;
  padding-right: 16px;
  margin: 4px 0;
}

table tbody td {
  min-width: 150px;
  max-width: 300px;
}

.error {
  font-weight: 400;
  font-size: 0.75rem;
  line-height: 1.66;
  text-align: left;
  margin-top: 3px;
  margin-right: 14px;
  margin-bottom: 0;
  color: #f44336;
}

.custonReactQuill .quill {
  height: 230px;
  margin-top: 10px;
}
.custonReactQuill .quill .ql-container {
  height: 180px;
}

.desciptionHtmlForm {
  width: 500px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  word-wrap: break-word;
}

.link {
  font-weight: 400;
  font-size: 0.875rem;
  line-height: 1.43;
  color: #909090;
  text-decoration: none;
}

.accordianStyle::before {
  background-color: none !important;
}
.accordianStyle .MuiAccordion-root:first-of-type {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.AddDrawerPapper {
  min-width: 75vh;
  max-width: 50%;
}

.settingAccordian .MuiPaper-root {
  border-radius: 0px !important;
}
.settingAccordian .MuiAccordion-root {
  border-radius: 16px !important;
  margin-bottom: 10px;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
}
.settingAccordian .MuiAccordion-root::before {
  background-color: transparent;
}

@media screen and (max-width: 769px) {
  .DeviceSheduletabStyle {
    width: 100%;
  }
  .DeviceSheduletabStyle .MuiTabs-root .MuiButtonBase-root {
    width: 125px;
    word-wrap: break-word;
  }
  .DeviceSheduletabStyle .MuiTabs-root .MuiButtonBase-root .successActive::before,
  .DeviceSheduletabStyle .MuiTabs-root .MuiButtonBase-root .inActive::before {
    font-size: 15px;
    right: 18%;
  }
  .DeviceSheduletabStyle .MuiTabs-root .MuiButtonBase-root .MuiTypography-root {
    font-size: 14px;
  }
}
@media screen and (max-width: 390px) {
  .DeviceSheduletabStyle {
    width: 100%;
  }
  .DeviceSheduletabStyle .MuiTabs-root .MuiButtonBase-root {
    width: 100px;
    font-size: 12px;
    word-wrap: break-word;
  }
  .DeviceSheduletabStyle .MuiTabs-root .MuiButtonBase-root .successActive::before,
  .DeviceSheduletabStyle .MuiTabs-root .MuiButtonBase-root .inActive::before {
    font-size: 15px;
    right: 18%;
    top: 15%;
  }
  .DeviceSheduletabStyle .MuiTabs-root .MuiButtonBase-root .MuiTypography-root {
    font-size: 12px;
  }
}

.customCardStyle .MuiPaper-root {
  border-radius: 16px !important;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.12), 0px 0px 0px 1px rgb(241, 241, 241);
}

.customCardRelayStyle .MuiPaper-root {
  border-radius: 16px;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.12), 0px 0px 0px 1px rgb(241, 241, 241);
}

.customCardSheduleStyle .MuiPaper-root {
  border-radius: 16px;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.12), 0px 0px 0px 1px rgb(241, 241, 241);
}

.customCardTableStyle .MuiPaper-root {
  border-radius: 16px;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.12), 0px 0px 0px 1px rgb(241, 241, 241);
}

.otpCustomStyleInput {
  justify-content: center;
  margin: 15px 0;
}
.otpCustomStyleInput input {
  width: 32px !important;
  height: 40px !important;
}

.drawerStyl {
  min-width: 45%;
  max-width: 45%;
}

.navitemBtn.active svg g {
  fill: #16b3d5 !important;
}
.navitemBtn.active svg path {
  fill: #16b3d5 !important;
}

.navitemBtnTwo.active svg g {
  stroke: #16b3d5 !important;
}
.navitemBtnTwo.active svg path {
  stroke: #16b3d5 !important;
}

.loderWraper {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.1);
  z-index: 11111;
}

.waitTimeClass .MuiSwitch-track {
  background-color: orange !important;
}

.infoDilog {
  background-color: #013865;
  color: #ffffff;
}`, "",{"version":3,"sources":["webpack://./src/style/main.scss","webpack://./src/style/sass/_mixins.scss","webpack://./src/style/sass/_variables.scss"],"names":[],"mappings":"AAAA,gBAAgB;;AAGhB;EACE,qBAAA;AAUF;AATE;EACE,UAAA;EACA,qBAAA;AAWJ;AATE;EACE,YAAA;AAWJ;;AAPA;EACE,kBAAA;AAUF;;AAPA;ECKI,aAAA;EACA,8BAAA;EACA,mBAAA;ADMJ;;AATA;EACE,aAAA;EACA,sBAAA;AAYF;;AATA;EACE,aAAA;AAYF;;AATA;EACE,+DAAA;EACA,mBAAA;AAYF;;AATA;EACE,gBAAA;EACA,mBAAA;AAYF;AAXE;EACE,yBEnCY;EFoCZ,WAAA;AAaJ;;AATA;EACE,cExCc;AFoDhB;;AATA;EACE,cE3CY;AFuDd;;AARE;EAOE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;AAKJ;;AADE;EAOE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;AAFJ;;AAOE;EACE,aAAA;EACA,eAAA;EACA,UAAA;AAJJ;;AAOA;EACE,mBAAA;AAJF;;AAMA;EACE,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;AAHF;;AAOI;EACE,gBAAA;EACA,gBAAA;AAJN;;AAQA;EACE,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EAEA,cAAA;AANF;;AAWE;EACE,aAAA;EACA,gBAAA;AARJ;AASI;EACE,aAAA;AAPN;;AAWA;EACE,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;AARF;;AAUA;EACE,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAAA;EACA,qBAAA;AAPF;;AAUE;EACE,iCAAA;AAPJ;AAUI;EACE,4BAAA;EACA,6BAAA;AARN;;AAcA;EACE,eAAA;EACA,cAAA;AAXF;;AAcE;EACE,6BAAA;AAXJ;AAaE;EACE,8BAAA;EACA,mBAAA;EACA,4BAAA;EACA,6BAAA;AAXJ;AAYI;EACE,6BAAA;AAVN;;AAeE;EADF;IAEI,WAAA;EAXF;EAaI;IACE,YAAA;IACA,qBAAA;EAXN;EAcQ;;IACE,eAAA;IACA,UAAA;EAXV;EAcM;IACE,eAAA;EAZR;AACF;AAgBE;EApBF;IAqBI,WAAA;EAbF;EAeI;IACE,YAAA;IACA,eAAA;IACA,qBAAA;EAbN;EAgBQ;;IACE,eAAA;IACA,UAAA;IACA,QAAA;EAbV;EAgBM;IACE,eAAA;EAdR;AACF;;AAoBE;EACE,8BAAA;EACA,+EAAA;AAjBJ;;AAqBE;EACE,mBAAA;EACA,+EAAA;AAlBJ;;AAsBE;EACE,mBAAA;EACA,+EAAA;AAnBJ;;AAuBE;EACE,mBAAA;EACA,+EAAA;AApBJ;;AAuBA;EACE,uBAAA;EACA,cAAA;AApBF;AAqBE;EACE,sBAAA;EACA,uBAAA;AAnBJ;;AAuBA;EACE,cAAA;EACA,cAAA;AApBF;;AA8BM;EACE,wBAAA;AA3BR;AA6BM;EACE,wBAAA;AA3BR;;AAmCM;EACE,0BAAA;AAhCR;AAkCM;EACE,0BAAA;AAhCR;;AAqCA;EACE,eAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;EACA,aAAA;EACA,oCAAA;EACA,cAAA;AAlCF;;AA0CE;EACE,mCAAA;AAvCJ;;AA2CA;EACE,yBAAA;EACA,cAAA;AAxCF","sourcesContent":["@import \"./sass/mixins.scss\";\n@import \"./sass/variables\";\n\n.frm-grp {\n  margin-bottom: 1.3rem;\n  &.half {\n    width: 48%;\n    display: inline-block;\n  }\n  &.right {\n    float: right;\n  }\n}\n\n.mr-15 {\n  margin-right: 15px;\n}\n\n.flexCenter {\n  @include flexCenter;\n}\n\n.flexColumn {\n  display: flex;\n  flex-direction: column;\n}\n\n.flex {\n  display: flex;\n}\n\n.theme_btn {\n  background: linear-gradient(90deg, #16b3d5 2.47%, #05c4ab 100%);\n  border-radius: 40px;\n}\n\n.outline_btn {\n  font-weight: 400;\n  border-radius: 50px;\n  &:hover {\n    background-color: $primary-color;\n    color: #fff;\n  }\n}\n\n.success {\n  color: $success-color;\n}\n\n.error {\n  color: $error-color;\n}\n\n.successActive {\n  &::before {\n    // content: \" \\25CF\";\n    // // font-size: 16px;\n    // color: #15f446;\n    // position: absolute;\n    // right: 15%;\n    // top: 0;\n    position: absolute;\n    right: 12%;\n    top: 28%;\n    content: \"\" !important;\n    width: 16px;\n    height: 16px;\n    border-radius: 50%;\n    border: 1px solid #15f446;\n    background: #15f446;\n  }\n}\n.inActive {\n  &::before {\n    // content: \" \\25CF\";\n    // // font-size: 16px;\n    // color: #a7b5c6;\n    // position: absolute;\n    // right: 15%;\n    // top: 0;\n    position: absolute;\n    right: 12%;\n    top: 28%;\n    content: \"\" !important;\n    width: 16px;\n    height: 16px;\n    border-radius: 50%;\n    border: 1px solid #a7b5c6;\n    background: #a7b5c6;\n  }\n}\n\n.errorActive {\n  &::before {\n    content: \" \\25CF\";\n    font-size: 20px;\n    color: red;\n  }\n}\n.commanBtnStyle {\n  border-radius: 40px;\n}\n.settingLabel {\n  padding-top: 8px;\n  padding-bottom: 8px;\n  padding-left: 16px;\n  padding-right: 16px;\n  margin: 4px 0;\n}\ntable {\n  tbody {\n    td {\n      min-width: 150px;\n      max-width: 300px;\n    }\n  }\n}\n.error {\n  font-weight: 400;\n  font-size: 0.75rem;\n  line-height: 1.66;\n  text-align: left;\n  margin-top: 3px;\n  margin-right: 14px;\n  margin-bottom: 0;\n  // margin-left: 14px;\n  color: #f44336;\n}\n\n// React Quill Style\n.custonReactQuill {\n  .quill {\n    height: 230px;\n    margin-top: 10px;\n    .ql-container {\n      height: 180px;\n    }\n  }\n}\n.desciptionHtmlForm {\n  width: 500px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  word-wrap: break-word;\n}\n.link {\n  font-weight: 400;\n  font-size: 0.875rem;\n  line-height: 1.43;\n  color: #909090;\n  text-decoration: none;\n}\n.accordianStyle {\n  &::before {\n    background-color: none !important;\n  }\n  .MuiAccordion-root {\n    &:first-of-type {\n      border-bottom-left-radius: 0;\n      border-bottom-right-radius: 0;\n    }\n  }\n}\n// .adminCard {\n// }\n.AddDrawerPapper {\n  min-width: 75vh;\n  max-width: 50%;\n}\n.settingAccordian {\n  .MuiPaper-root {\n    border-radius: 0px !important;\n  }\n  .MuiAccordion-root {\n    border-radius: 16px !important;\n    margin-bottom: 10px;\n    border-top-left-radius: 16px;\n    border-top-right-radius: 16px;\n    &::before {\n      background-color: transparent;\n    }\n  }\n}\n.DeviceSheduletabStyle {\n  @media screen and (max-width: 769px) {\n    width: 100%;\n    .MuiTabs-root {\n      .MuiButtonBase-root {\n        width: 125px;\n        word-wrap: break-word;\n        .successActive,\n        .inActive {\n          &::before {\n            font-size: 15px;\n            right: 18%;\n          }\n        }\n        .MuiTypography-root {\n          font-size: 14px;\n        }\n      }\n    }\n  }\n  @media screen and (max-width: 390px) {\n    width: 100%;\n    .MuiTabs-root {\n      .MuiButtonBase-root {\n        width: 100px;\n        font-size: 12px;\n        word-wrap: break-word;\n        .successActive,\n        .inActive {\n          &::before {\n            font-size: 15px;\n            right: 18%;\n            top: 15%;\n          }\n        }\n        .MuiTypography-root {\n          font-size: 12px;\n        }\n      }\n    }\n  }\n}\n.customCardStyle {\n  .MuiPaper-root {\n    border-radius: 16px !important;\n    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.12), 0px 0px 0px 1px rgb(241, 241, 241);\n  }\n}\n.customCardRelayStyle {\n  .MuiPaper-root {\n    border-radius: 16px;\n    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.12), 0px 0px 0px 1px rgb(241, 241, 241);\n  }\n}\n.customCardSheduleStyle {\n  .MuiPaper-root {\n    border-radius: 16px;\n    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.12), 0px 0px 0px 1px rgb(241, 241, 241);\n  }\n}\n.customCardTableStyle {\n  .MuiPaper-root {\n    border-radius: 16px;\n    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.12), 0px 0px 0px 1px rgb(241, 241, 241);\n  }\n}\n.otpCustomStyleInput {\n  justify-content: center;\n  margin: 15px 0;\n  input {\n    width: 32px !important;\n    height: 40px !important;\n    // border-radius: 6px;\n  }\n}\n.drawerStyl {\n  min-width: 45%;\n  max-width: 45%;\n}\n// .navLabel {\n//   .MuiListSubheader-root {\n//     padding: 0 0 10px !important;\n//   }\n// }\n.navitemBtn {\n  &.active {\n    svg {\n      g {\n        fill: #16b3d5 !important;\n      }\n      path {\n        fill: #16b3d5 !important;\n      }\n    }\n  }\n}\n.navitemBtnTwo {\n  &.active {\n    svg {\n      g {\n        stroke: #16b3d5 !important;\n      }\n      path {\n        stroke: #16b3d5 !important;\n      }\n    }\n  }\n}\n.loderWraper {\n  position: fixed;\n  left: 0;\n  top: 0;\n  width: 100vw;\n  height: 100vh;\n  background-color: rgba(0, 0, 0, 0.1);\n  z-index: 11111;\n}\n// .resetAutocomplete{\n//   .MuiAutocomplete-endAdornment\t{\n//     // right: 20px;\n//   }\n// }\n.waitTimeClass {\n  .MuiSwitch-track {\n    background-color: orange !important;\n  }\n}\n\n.infoDilog {\n  background-color: #013865;\n  color: #ffffff;\n}\n","\n@mixin respond($breakpoint) {\n    @if $breakpoint == small-phone {\n        @media only screen and (max-width: 30em) { @content };    //480px\n    }\n    @if $breakpoint == phone {\n        @media only screen and (max-width: 47.9375em) { @content };    //767px\n    }\n    @if $breakpoint == tab-port {\n        @media only screen and (max-width: 61.875em) { @content };     //900px\n    }\n    @if $breakpoint == large-tab-port {\n        @media only screen and (max-width: 991px) { @content };     //900px\n    }\n    @if $breakpoint == tab-land {\n        @media only screen and (max-width: 75em) { @content };    //1200px\n    }\n    @if $breakpoint == big-desktop {\n        @media only screen and (min-width: 112.5em) { @content };    //1800\n    }\n}\n\n@mixin flexCenter {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n@mixin flexVerticalCenter {\n    display: flex;\n    align-items: center;\n}\n\n@mixin flexColumn {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n}","\n// :root{\n//     --color-pink: #F3C;\n// } \n\n$primary-color: #16b3d5;\n$success-color: #4caf50;\n$error-color: #f44336;\n$active-color: #6b778c;\n$text-primary: #0f265c;\n$text-secondary: #909090;\n$warning-color: #ff9800;\n$icon-color: #9CA2A4;\n\n$primary-font: 'Nunito', sans-serif; // weights 400 700\n:export {\n    primaryColor: $primary-color;\n    successColor: $success-color;\n    errorColor: $error-color;\n    primaryFont: $primary-font;\n    activeColor: $active-color;\n    textPrimaryColor: $text-primary;\n    textSecColor: $text-secondary;\n    warningColor: $warning-color;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primaryColor": `#16b3d5`,
	"successColor": `#4caf50`,
	"errorColor": `#f44336`,
	"primaryFont": `"Nunito", sans-serif`,
	"activeColor": `#6b778c`,
	"textPrimaryColor": `#0f265c`,
	"textSecColor": `#909090`,
	"warningColor": `#ff9800`
};
export default ___CSS_LOADER_EXPORT___;
